module.exports = __webpack_public_path__ + "img/fylke-18.2a61b81f.svg";